import { graphql } from "../../gql/index.ts";
import { useMutation } from "@apollo/client";
import { useCallback } from "react";
import { GetUserFrozenWeeksQuery } from "./FreezeWeek/useUserFrozenWeeks.ts";
import { GetUserFreezableWeeksQuery } from "./FreezeWeek/useUserFreezableWeeks.ts";
import { GetUserRemainingLessonsQuery } from "./useUserRemainingLessons.ts";

const MergeUnlimitedPlansMutation = graphql(`
  mutation mergeUnlimitedPlans($firstPlanId: String!, $secondPlanId: String!) {
    mergeUnlimitedPlans(
      firstPlanId: $firstPlanId
      secondPlanId: $secondPlanId
    ) {
      ...ClassRoomPlanFragment
    }
  }
`);

export function useMergeUnlimitedPlans() {
  const [mergeUnlimitedPlansMutation, { loading }] = useMutation(
    MergeUnlimitedPlansMutation,
    {
      refetchQueries: [
        GetUserFrozenWeeksQuery,
        GetUserFreezableWeeksQuery,
        GetUserRemainingLessonsQuery,
      ],
    },
  );

  const mergeUnlimitedPlans = useCallback(
    async (firstPlanId: string, secondPlanId: string) => {
      await mergeUnlimitedPlansMutation({
        variables: {
          firstPlanId,
          secondPlanId,
        },
      });
    },
    [mergeUnlimitedPlansMutation],
  );

  return { mergeUnlimitedPlans, loading };
}
